import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Radio, CalendarDays, Signal, Play } from 'lucide-react';

// Permanent banner — the interview is now available on demand.

export default function LycaRadioBanner() {
  return (
    <section className="bg-emerald-950 py-6 md:py-8" data-testid="lyca-radio-banner">
      <div className="max-w-6xl mx-auto px-4">
        <div className="rounded-2xl border border-amber-400/30 bg-gradient-to-br from-emerald-900 to-emerald-950 p-6 md:p-7 shadow-xl">
          <div className="flex flex-col md:flex-row md:items-center gap-5">
            <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-amber-400/15 flex items-center justify-center">
              <Radio className="w-7 h-7 text-amber-300" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[11px] uppercase tracking-[0.28em] text-amber-300 font-semibold mb-1">As heard on air</p>
              <h2 className="text-white text-xl md:text-2xl font-bold font-heading leading-tight">
                IIY Phytoventra on Lyca Radio — Bridging Herbal Heritage with Clinical Plant Science
              </h2>
              <p className="text-emerald-100/90 text-sm mt-2 leading-relaxed">
                Our Co-Founder &amp; Director <strong className="text-white">Rupinderjit Kaur (Jaz Sidhu)</strong> joins
                broadcaster <strong className="text-white">Keith Vaz</strong> on <em>Talking Points</em> to discuss
                proactive wellness, tradition meeting modern rigour, and clinically studied high-absorption turmeric.
              </p>
              <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm text-emerald-100">
                <span className="inline-flex items-center gap-1.5"><CalendarDays className="w-4 h-4 text-amber-300" /> Sunday, 20 September 2026</span>
                <span className="inline-flex items-center gap-1.5"><Signal className="w-4 h-4 text-amber-300" /> Lyca Radio 1458 · Greater London</span>
              </div>
            </div>
            <div className="flex-shrink-0 w-full md:w-72">
              <Link to="/lyca-radio-interview" className="block relative rounded-xl overflow-hidden border border-amber-400/20 bg-black/30 aspect-video group" data-testid="lyca-video">
                <img src="/lyca-interview-poster.jpg" alt="Watch the Lyca Radio interview" className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform" loading="lazy" />
                <span className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-400 text-emerald-950 shadow-lg group-hover:scale-105 transition-transform">
                    <Play className="w-5 h-5 fill-emerald-950 ml-0.5" />
                  </span>
                </span>
              </Link>
              <Link
                to="/lyca-radio-interview"
                data-testid="lyca-listen-btn"
                className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 hover:bg-amber-300 text-emerald-950 font-bold px-6 py-3 transition-colors"
              >
                <Play className="w-4 h-4 fill-emerald-950" /> Watch the interview
              </Link>
              <p className="text-[11px] text-emerald-200/80 mt-2 text-center">Also on YouTube &amp; LycaRadio.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
